var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-image-preview',{staticClass:"ceshi",attrs:{"images":_vm.images,"loop":_vm.loop,"overlay-style":{
    zIndex: '99999 !important'
  }},on:{"change":_vm.onChange},scopedSlots:_vm._u([{key:"index",fn:function(){return [_vm._v("第"+_vm._s(_vm.index+1)+"页")]},proxy:true}]),model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }